import type { VariantProps } from "class-variance-authority"

import { Badge, type badgeVariants } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"]

function agentStateVariant(state: string): BadgeVariant {
  switch (state) {
    case "operational":
    case "paused":
    case "degraded":
    case "draft":
    case "retired":
      return state as BadgeVariant
    default:
      return "outline"
  }
}

interface AgentStateBadgeProps {
  state: string
  needsAttention?: boolean
  className?: string
}

export function AgentStateBadge({
  state,
  needsAttention,
  className,
}: AgentStateBadgeProps) {
  if (needsAttention) {
    return (
      <Badge variant="warning" className={cn("shrink-0", className)}>
        Needs Attention
      </Badge>
    )
  }

  return (
    <Badge
      variant={agentStateVariant(state)}
      className={cn("shrink-0 capitalize", className)}
    >
      {state}
    </Badge>
  )
}
